<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-mute-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.68 6H25a2 2 0 011.994 1.85L27 8v32a2 2 0 01-1.85 1.995L25 42h-1.32c-.378 0-.747-.107-1.065-.307l-.154-.108-11.68-8.985a1.996 1.996 0 01-.774-1.417L10 31.015v-14.03c0-.564.238-1.1.652-1.477l.129-.108 11.68-8.985c.3-.23.657-.37 1.03-.406L23.68 6H25h-1.32zM6 16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V17a1 1 0 011-1h2zm25.121.707a1 1 0 011.415 0l4.242 4.242 4.243-4.242a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.415l-4.243 4.242 4.243 4.243a1 1 0 01.083 1.32l-.083.094-1.414 1.414a1 1 0 01-1.414 0l-4.243-4.243-4.242 4.243a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.414l4.242-4.243-4.242-4.242a1 1 0 01-.083-1.32l.083-.095 1.414-1.414z"/></svg>
</template>
<script>

export default {
  name: 'IconMuteFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
